export const X_WEB_API = window.chrome || window.browser || {};
